import React, { useState } from 'react';
import InputMask from 'react-input-mask';
import {
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton,
  FormHelperText
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

const PhoneInputWithEncryption = ({ label = 'Phone Number', error }) => {
  const [phone, setPhone] = useState('');
  const [showDecrypted, setShowDecrypted] = useState(true);

  const handleToggleVisibility = () => {
    setShowDecrypted((prev) => !prev);
  };

  const handlePhoneChange = (e) => {
    const rawValue = e.target.value.replace(/\D/g, ''); // remove non-digits
    if (rawValue.length <= 10) {
      setPhone(rawValue);
    }
  };

  const formatPhone = (digits) => {
    const match = digits.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
    if (!match) return '';
    const [, area, prefix, line] = match;
    let result = '';
    if (area) result += area;
    if (prefix) result += '-' + prefix;
    if (line) result += '-' + line;
    return result;
  };

  const getDisplayedValue = () => {
    return showDecrypted
      ? formatPhone(phone)
      : phone.length === 10
        ? '***-***-****'
        : '';
  };

  return (
    <FormControl
      fullWidth
      variant="outlined"
      error={!!error}
      required
      sx={{ mt: 2 }}
    >
      <InputLabel htmlFor="phone-input">{label}</InputLabel>
      <OutlinedInput
        id="phone-input"
        label={label}
        value={getDisplayedValue()}
        onChange={handlePhoneChange}
        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle phone visibility"
              onClick={handleToggleVisibility}
              edge="end"
            >
              {showDecrypted ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        }
      />
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

export default PhoneInputWithEncryption;
